<template>
  <card class="card" title="Informations du site">
    <div>
      <form @submit.prevent="updateSetting()">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="tel" label="Contact" v-model="contact">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="email" label="Email" v-model="email">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Lien Facebook" v-model="facebook">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Lien Twitter" v-model="twitter">
            </fg-input>
          </div>
        </div>


        <div class="text-center">
          <button type="submit" class="btn btn-info rounded">
            Mettre à jour
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import API from "../../services/api-request.js";

export default {
  data() {
    return {
      contact: "",
      email: "",
      facebook: "",
      twitter: "",
      id: "",

    };
  },
  methods: {
    updateSetting() {
      API.update(
        this.id,
        {
          contact: this.contact,
          email: this.email,
          facebook: this.facebook,
          twitter: this.twitter,
        },
        'setting'

      ).then(() => {
        //# alert success
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Paramètres mis a jour",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    },
    getInfo(id) {
      API.index('setting').then((response) => {
        this.id = response.data[0].id;
        this.contact = response.data[0].contact;
        this.email = response.data[0].email;
        this.facebook = response.data[0].facebook;
        this.twitter = response.data[0].twitter;
      });
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>
<style></style>
